// import { getMerchants, getMerchantDishes } from '../io/repositories/merchant_repository'
const REPO = require('../../io/repositories/user_repository')
const state = {
  user: {}
}

const getters = {
  getUserId (state) {
    return state.user.id
  }
  // getName (state) {
  //   return state.name
  // }
}

const mutations = {
  SET_USER (state, data) {
    state.user = data
  }
}

const actions = {
  async LOAD_USER (context) {
    const resp = await REPO.loadMe()
    context.commit('SET_USER', resp)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
